import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgV2Folder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "20px",
	height: "18px",
	viewBox: "0 0 20 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "dib_checklists_new-concpet",
			transform: "translate(-337.000000, -90.000000)",
			fill: "currentColor",
			fillRule: "nonzero",
			stroke: "currentColor",
			strokeWidth: .8,
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-7",
				transform: "translate(39.000000, 91.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-4",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group-9",
						children: /* @__PURE__ */ _jsx("g", {
							id: "folder-(1)",
							transform: "translate(299.000000, 0.000000)",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M7.87598437,1.0619469 L7.17285937,0 L2,0 C0.8954305,2.02906125e-16 -1.3527075e-16,0.8954305 0,2 L0,14 C1.3527075e-16,15.1045695 0.8954305,16 2,16 L16,16 C17.1045695,16 18,15.1045695 18,14 L18,1.0619469 L18,1.0619469 L7.87598437,1.0619469 Z M14.9453125,14.9380531 L3.0546875,14.9380531 C1.950118,14.9380531 1.0546875,14.0426226 1.0546875,12.9380531 L1.0546875,3.0619469 C1.0546875,1.9573774 1.950118,1.0619469 3.0546875,1.0619469 L6.60839063,1.0619469 L6.60839063,1.0619469 L8.71776563,5.24778761 L16.9453125,5.24778761 L16.9453125,12.9380531 C16.9453125,14.0426226 16.049882,14.9380531 14.9453125,14.9380531 Z M16.9453125,4.18584071 L9.28219922,4.18584071 L8.57907422,2.12389381 L16.9453125,2.12389381 L16.9453125,4.18584071 Z",
								id: "Shape"
							})
						})
					})
				})
			})
		})
	})
});
export default SvgV2Folder;
